import React, { useState, useCallback } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import ChatHistorySidebar from './chatHistorySidebar';
import ChatAssistant from './chatAssistant';
import './style.css';

const HubWalletAssistant: React.FC = () => {
  const [activeSession, setActiveSession] = useState<string | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth > 980);

  const handleNewChat = useCallback(() => {
    setActiveSession(null);
  }, []);

  const handleSessionCreated = useCallback((id: string) => {
    setActiveSession(id);
    setRefreshTrigger((n) => n + 1);
  }, []);

  const handleSessionsChanged = useCallback(() => {
    setRefreshTrigger((n) => n + 1);
  }, []);

  const handleSelectSession = useCallback((id: string) => {
    setActiveSession(id);
    if (window.innerWidth <= 980) setSidebarOpen(false);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden">
      <SideMenuBar sideMenuBarClass="w-64 h-screen bg-white shrink-0" />
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Shared navbar */}
        <div className="bg-white border-b border-gray-100 shadow-sm px-4 py-3 shrink-0 flex items-center gap-3 ipad-padding-left">
          <button
            onClick={() => setSidebarOpen((s) => !s)}
            className="p-1.5 rounded-lg hover:bg-gray-100 text-gray-500 transition-colors shrink-0"
            title={sidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d={sidebarOpen ? 'M15 19l-7-7 7-7' : 'M9 5l7 7-7 7'} />
            </svg>
          </button>
          <div>
            <h1 className="text-base font-semibold text-gray-800">AI Assistant</h1>
            <p className="text-xs text-gray-400">AI-powered customer feedback analyst</p>
          </div>
        </div>
        {/* Sidebar + Chat */}
        <div className="flex flex-1 overflow-hidden">
          <ChatHistorySidebar
            isOpen={sidebarOpen}
            activeSession={activeSession}
            onSelectSession={handleSelectSession}
            onNewChat={handleNewChat}
            onClose={() => setSidebarOpen(false)}
            refreshTrigger={refreshTrigger}
          />
          <div className="flex-1 overflow-hidden transition-all duration-300">
            <ChatAssistant
              sessionId={activeSession}
              onSessionCreated={handleSessionCreated}
              onSessionsChanged={handleSessionsChanged}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubWalletAssistant;
